import { ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogService, UiConfirmDialogComponent } from './confirmdialog';
import { UiCardBundle } from './card';
import { UiButtonComponent } from './button';
import { UiFieldWrapperComponent } from './field-wrapper';
import { UiSpinnerComponent } from './spinner';
import { UiScrollPanelComponent } from './scrollpanel';
import { UiIconsModule } from './icons';
import { UiMenuComponent } from './menu';
import { UiMessageComponent } from './message';
import { UiContainerComponent } from './container';
import { UiMenubarComponent } from './menubar';
import { UiHelpButtonComponent } from './help-button';
import { UiGridComponent } from './grid';
import { UiPanelBundle } from './panel';
import { UiFeatureHighlightComponent } from './feature-highlight';
import { UiContentCenteredComponent } from './content-centered';
import { trueSingletonFactory } from '@core/frontend-shared';
import { UiLogoComponent } from './logo/logo';
import * as i0 from "@angular/core";
import * as i1 from "./card/card";
import * as i2 from "./shared/shared";
import * as i3 from "./panel/panel";
const uiModules = [CommonModule, UiIconsModule, UiScrollPanelComponent, UiContentCenteredComponent, UiFieldWrapperComponent, UiContainerComponent, UiCardBundle, UiButtonComponent, UiHelpButtonComponent, UiSpinnerComponent, UiMenuComponent, UiMenubarComponent, UiMessageComponent, UiGridComponent, UiFeatureHighlightComponent, UiPanelBundle, UiLogoComponent, UiConfirmDialogComponent // must be provided to app components!
];
export let MinimalUiModule = /*#__PURE__*/(() => {
  class MinimalUiModule {
    static forRoot() {
      return {
        ngModule: MinimalUiModule,
        providers: [{
          provide: ConfirmDialogService,
          useFactory: trueSingletonFactory(() => new ConfirmDialogService())
        }]
      };
    }
    static {
      this.ɵfac = function MinimalUiModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MinimalUiModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MinimalUiModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, UiIconsModule, UiScrollPanelComponent, UiFieldWrapperComponent, i1.UiCardComponent, UiButtonComponent, UiHelpButtonComponent, UiSpinnerComponent, UiMenuComponent, UiMenubarComponent, UiMessageComponent, UiGridComponent, UiFeatureHighlightComponent, i3.UiPanelComponent, UiLogoComponent, UiConfirmDialogComponent, CommonModule, UiIconsModule]
      });
    }
  }
  return MinimalUiModule;
})();